<div class="dropdown dropdown-hover dropdown-insert-pessoa-contato" [class.dropup]="dropup">
    <button class="btn {{classBtn}} dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-plus" aria-hidden="true"></i> Novo Contato
    </button>
    <div class="dropdown-menu">
        <h6 class="dropdown-header">Selecione o tipo do contato</h6>
        <button type="button" class="dropdown-item" *ngFor="let tipoContato of tiposContatos" (click)="insert.emit(tipoContato)">
            {{tipoContato.nome}}
        </button>
    </div>
</div>